import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import {
  holdProperty,
  releaseHoldProperty,
  resetAvailabilityErrorStatus,
  // eslint-disable-next-line prettier/prettier
  resetNavigationStatus
} from '../../../features/offerAvailability/offerAvailabilitySlice';
import { AvailableDates, ReleaseHoldPropertyRequest } from '../../../features/offerAvailability/types';
import { RootState } from '../../../redux/rootReducer';
import { getHumanReadableTime } from '../../../util/date';
import { OFFER_DATES_PATH } from '../../../util/strings';
import ErrorMessage from '../../common/ErrorMessage';
import ParseHtml from '../../common/ParseHtml';
import withLocalization from '../../hoc/withLocalization';
import './CountdownTimer.scss';

type onTimerCompletedType = () => void;
interface TimerPropType {
  countdownDuration: number;
  onTimerCompleted?: onTimerCompletedType;
  localize: any;
  history?: any;
}

const ConuntdownTimer: FC<TimerPropType> = (props: TimerPropType): ReactElement => {
  const availabilityDates: AvailableDates = useSelector((state: RootState) => state.availabilityDates);
  const holdSessionId = availabilityDates.holdSessionId;
  const isLoading = availabilityDates.isLoading;
  const hasError = availabilityDates.hasError;
  const error = hasError ? <ErrorMessage errorObject={availabilityDates.error}></ErrorMessage> : <></>;
  const { countdownDuration, onTimerCompleted, localize } = props;
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [timeRemaining, setRemainingTime] = useState(countdownDuration);
  const onRehold = () => {
    if (availabilityDates && availabilityDates.holdRequest) {
      dispatch(holdProperty(availabilityDates.holdRequest));
    }
  };
  const onNavigateToAvailability = () => {
    handleClose();
    dispatch(resetNavigationStatus());
    dispatch(resetAvailabilityErrorStatus());
    setTimeout(() => {
      props.history.push(OFFER_DATES_PATH);
    }, 0);
  };
  useEffect(() => {
    if (!timeRemaining) {
      if (holdSessionId) {
        const releaseRequest: ReleaseHoldPropertyRequest = {
          holdId: holdSessionId,
        };
        dispatch(releaseHoldProperty(releaseRequest));
      }
      handleShow();
      if (onTimerCompleted) {
        onTimerCompleted();
      }

      return;
    }

    const intervalId = setInterval(() => {
      setRemainingTime(timeRemaining - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeRemaining, onTimerCompleted, dispatch, holdSessionId]);

  useEffect(() => {
    if (!isLoading && !hasError) {
      setRemainingTime(countdownDuration);
      handleClose();
    }
    if (!isLoading && hasError) {
      dispatch(resetNavigationStatus());
      setTimeout(() => {
        props.history.push(OFFER_DATES_PATH);
      }, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, hasError, countdownDuration]);

  return (
    <>
      <span className="countdownclock">
        <ParseHtml
          htmlInput={localize(
            'preview-sales-engine.static-content.copy.hold-component.hold-component-instruction',
            `<strong>${getHumanReadableTime(timeRemaining)}`,
          )}
        />
      </span>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        dialogClassName="modal-custom-timer"
        animation={false}
      >
        <Modal.Header>{error}</Modal.Header>
        <Modal.Body>
          {localize('preview-sales-engine.static-content.copy.hold-component.hold-overlay-instructio')}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onNavigateToAvailability}>
            {localize('preview-sales-engine.static-content.copy.hold-component.select-a-new-date-button')}
          </Button>
          <Button variant="primary" onClick={onRehold}>
            {localize('preview-sales-engine.static-content.copy.hold-component.re-hold-button')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default withRouter(withLocalization(ConuntdownTimer));
